import $ from 'jquery';
import {Swiper, Navigation, Autoplay} from 'swiper/swiper.esm.js';
Swiper.use([Navigation, Autoplay]);

const swiper = new Swiper('.parks-swiper', {
        slidesPerView: 1,
        loop: true,
        navigation: {
            nextEl: '.parks-swiper-button-next',
            prevEl: '.parks-swiper-button-prev',
        }
});
